<template lang="pug">
	.test
</template>
<script>
	export default {
		name: 'Button',
		props: {
			inputType: {
				type: String
			},
			content: {
				type: Object
			},
			wait: {
				type: Boolean
			},
			informationID: {
				type: Number
			}
		}
	}
</script>
<style lang="sass">
	
</style>